import { FULFILL_LOGIN, AUTHENTICATE_LOGIN, AUTHORIZE_LOGIN, LOGOUT, SIGNUP, LOGIN_FAILED } from '../constants/loginConstants'

export const fulfillLogin = login => ({ type: FULFILL_LOGIN, login })
export const authenticateLogin = credentials => ({ type: AUTHENTICATE_LOGIN, credentials })
export const authorizeLogin = () => ({ type: AUTHORIZE_LOGIN })
export const logout = () => ({ type: LOGOUT })
export const signup = form => ({ type: SIGNUP, form })
export const loginFailed = () => ({ type: LOGIN_FAILED })